import React from "react";
import { datadogLogs } from '@datadog/browser-logs';

interface ErrorBoundaryProps {
	children: React.ReactNode;
	fallback: React.ReactNode;
}

interface ErrorBoundaryState {
	hasError: boolean;
	error: Error | null;
}

// At the time of coding, 21.03.2025, there is no way functional way to implement an error boundary.
// Class based error boundaries are the only way to catch all errors, including rendering errors.
// If and when React decides to implement it then we'll update to that.
class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		// eslint-disable-next-line react/no-unused-state
		this.state = { hasError: false, error: null};
	}

	static getDerivedStateFromError(error: Error) {
		return { hasError: true, error: error };
	}

	componentDidCatch(error: Error, errorInfo) {
		datadogLogs.logger.error(error.message, {
			componentStack: errorInfo.componentStack
		}, error);
		console.error(error, errorInfo);
	}

	render() {
		const { hasError } = this.state;
		const { children, fallback } = this.props;
		if (hasError) {
			return fallback;
		}

		return children;
	}
}

export default ErrorBoundary
